import { create } from 'zustand'

export const useFormStateStore = create((set) => ({
	form: [],
	orphanForms: [],
	fillForm: (form) => set({ form }),
	setOrphanForms: (orphanForms) => set({ orphanForms }),
	emptyForm: () => set({ form: [] }),
}))
